import "./styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import useFilters from "../../customHooks/useFilters";
import Header from "./Header";
import { Context } from "../..";
import Emptiness from "../../components/UI/emptiness/Emptiness";
import Spinner from "../../components/UI/spinner/Spinner";
import { observer } from "mobx-react-lite";
import Timofey from "../../assets/images/Timofey_avatar.png";
import { IControlAdmin, IUsers } from "../../models/IUsers";
import Button from "../../components/UI/button/GgButton";
import { useModal } from "../../customHooks/useModal";
import Modal from "../../components/modal/Modal";
import EditUser from "./EditUser";
import { showErrorToast, showSuccessToast } from "../../components/toasts";
import * as yup from 'yup';
import CustomSelect from "../../components/UI/customSelect/CustomSelect";
import { useSelect } from "../../customHooks/useSelect";

const SubAdmin: FC = () => {
  const { roles, store, users } = useContext(Context);
  const statusFilter = useFilters();
  const [loading, setLoading] = useState(false);
  const [rolesList, setUsersList] = useState<any>([]);
  const [fetchSigleUser, setFetchSigleUser] = useState<any>();

  const [status, setStatus] = useState<boolean>(false);
  const selectStatus = useSelect();


  const [allData, setAllData] = useState<any>({ data: [] });

  const schemaObject = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
    password: yup.string().required().min(8).matches(/^(?=.*\d)(?=.*[@#$%^&*!])[A-Za-z\d@#$%^&*!]+$/, 'Password must contain at least 1 number and 1 special character'),
    role: yup.array().required().min(1),
  });

  const [userData, setUserData] = useState<IControlAdmin>({
    name: "",
    email: "",
    role: [],
    isActive: true,
  });
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "control")?.children?.find((child: any) => child.path === "assignRoles")
    setAdminPermissionData(userData)
  };

  const modal = useModal();
  const editModal = useModal();

  async function loadUserData() {
    setLoading(true)
    try {
      const response = await roles.getUserData();
      setUsersList(response);
      setAllData(response)
      setLoading(false)
    } catch (error) {
      console.error("Error while fetching data", error)
    }

    setLoading(false)
  }

  const handleDeleteUser = async (id: string) => {
    try {
      if (window.confirm("Are you sure you want to delete this user ?")) {
        await roles.deleteAdminUser(id);
        loadUserData()
      }
    } catch (error) {
      console.error("User is not deleted")
    }
  }

  const handleFetchUser = async (id: string) => {
    try {
      const fetchUser = await roles.fetchSingleUserById(id);
      setFetchSigleUser(fetchUser?.data);
      editModal.openModal()
    } catch (error) {

    }
  }

  const hanldeUpdateUserData = async (id: string, roleData: any) => {
    const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const PASS_REGEX = /^(?=.*\d)(?=.*[@#$%^&*!])[A-Za-z\d@#$%^&*!]+$/;

    let userNewData = { ...fetchSigleUser }

    const updatedData = { ...userNewData, role: roleData }
    if (!updatedData?.name) {
      showErrorToast("Name field is required!");
    } else if (!updatedData?.email || !EMAIL_REGEX.test(updatedData?.email)) {
      showErrorToast("Valid email is required!");
    } else if (updatedData.role.length === 0) {
      showErrorToast("Role field is required!");
    } else {
      editModal.setModalShow(false);
      roles.updateAdminUser(id, updatedData)
        .then((data: any) => {
          setFetchSigleUser(null)
          loadUserData()
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const handleSave = (e: any) => {
    const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const PASS_REGEX = /^(?=.*\d)(?=.*[@#$%^&*!])[A-Za-z\d@#$%^&*!]+$/;

    if (!userData?.name) {
      showErrorToast("Name field is required!");
    } else if (!userData?.email || !EMAIL_REGEX.test(userData?.email)) {
      showErrorToast("Valid email is required!");
    } else if (!userData?.password || !PASS_REGEX.test(userData?.password)) {
      showErrorToast("Your password must include min 8 digit contain: 123, abc, /, #, @");
    } else if (e?.length === 0) {
      showErrorToast("Role field is required!" + e.length);
    } else {
      modal.setModalShow(false);
      roles.postUserData({ ...userData, role: e })
        .then((data: any) => {
          setUserData({
            name: "",
            email: "",
            password: "",
            role: [],
            isActive: true,
          });
          setUsersList((prev: any) => ({
            ...prev,
            data: [...prev.data, data?.newUser]
          }))
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const searchItems = (searchValue: string) => {
    if (searchValue !== "") {
      const filteredData = allData?.data?.filter((item: any) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setUsersList({ data: filteredData });
    } else {
      setUsersList(allData);
    }
  };

  const handleUseStatus = async (id: string, value: boolean) => {
    const data = {
      isActive: value
    }
    const list = [...rolesList.data].map(item => {
      if (item._id === id) {
        return {
          ...item,
          isActive: value
        }
      }
      return item
    })
    setUsersList({ ...rolesList, data: list })
    await roles.updateUserStatus(id, data)
  }

  useEffect(() => {
    loadUserData()
  }, [])

  return (
    <div className="users" style={{ display: "block" }}>
      <form >
        <Header
          searchItems={searchItems}
          data={userData}
          setUserData={setUserData}
          handleSave={handleSave}
          showModal={modal.showModal}
          setShowModal={modal.setModalShow}
          actionData={adminPermissionData}
        />
      </form>
      <div className="body" >
        {rolesList?.data && rolesList?.data?.length > 0 && !loading ? (
          rolesList?.data?.map((value: any, index: number) => (
            <div className="user" key={index} style={{ display: "flex" }}>
              <div className="content">
                <ul className="info">
                  <li className="name">{value?.name}</li>
                  <li className="email additional">Email: {value?.email}</li>
                  {/* <li className="email additional">Password: {value.password}</li> */}
                  <li>Role:</li>
                  <li className="phone additional" style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "15px",
                    marginTop: "1rem"
                  }}>
                    {value?.role?.map((parrentRole: any, index: number) => {
                      return (
                        <div>
                          <div style={{ display: "flex", fontWeight: "800" }}>
                            <div className="name" style={{ fontWeight: "bold" }}>{parrentRole?.title}</div>
                          </div>
                          <div style={{ marginLeft: "1rem" }}>
                            {parrentRole && parrentRole.children ? (
                              parrentRole.children.map((itemChild: any, index: number) => (
                                <div key={index} style={{ display: "flex", padding: "0.3rem", flexDirection: "column" }}>
                                  <div className="name" style={{ fontSize: "14px", fontWeight: "600" }}>{itemChild?.title}</div>
                                  {(itemChild?.add || itemChild?.edit || itemChild?.delete) && <div style={{ display: "flex", gap: 10, }}>
                                    {
                                      itemChild?.add && <div style={{
                                        fontSize: "12px",
                                        border: "1px #c1c1c1 solid",
                                        borderRadius: "1rem",
                                        padding: "3px 9px",
                                        color: "#000"
                                      }} >ADD</div>
                                    }
                                    {
                                      itemChild?.edit && <div style={{
                                        fontSize: "12px",
                                        border: "1px #c1c1c1 solid",
                                        borderRadius: "1rem",
                                        padding: "3px 9px",
                                        color: "#000"
                                      }}>EDIT</div>
                                    }{
                                      itemChild?.delete && <div style={{
                                        fontSize: "12px",
                                        border: "1px #c1c1c1 solid",
                                        borderRadius: "1rem",
                                        padding: "3px 9px",
                                        color: "#000"
                                      }}>DELETE</div>
                                    }
                                  </div>}
                                </div>
                              ))
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )
                    })}
                  </li>
                </ul>
              </div>
              <div className="controls" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div className="userStatus" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>User Status</div>
                  <div className="toggle-switch" style={{ marginLeft: "1rem" }}>
                    <input type="checkbox" className="checkbox"
                      name="Active" id={value?.email}
                      onChange={(e) => handleUseStatus(value?._id, e?.target?.checked)}
                      checked={value?.isActive} />
                    <label className="label" htmlFor={value?.email}>
                      <span className="inner" />
                      <span className="switch" />
                    </label>
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  {adminPermissionData?.edit ?
                    (
                      <Button onPress={() => handleFetchUser(value?._id)} stylesType="border" label="Edit" />
                    ) : ""}
                  {adminPermissionData?.delete ? (
                    <Button onPress={() => handleDeleteUser(value?._id)} stylesType="border" label="delete" style={{ marginLeft: "0.5rem" }} />
                  ) : ""}
                </div>
              </div>
            </div>
          ))
        ) : rolesList?.data && rolesList.data.length === 0 && !loading ? (
          <Emptiness icon={Timofey} content="There are no roles yet" />
        ) : (
          <Spinner />
        )}
      </div>
      <Modal
        show={editModal.showModal}
        onClose={editModal.setModalShow}
        title="Edit User"
      >
        <EditUser
          fetchSigleUser={fetchSigleUser}
          setFetchSigleUser={setFetchSigleUser}
          hanldeUpdateUserData={hanldeUpdateUserData}
          roles={roles}
        />
      </Modal>
    </div>
  );
};

export default observer(SubAdmin);
